import { render, staticRenderFns } from "./ActionsMenuItem.vue?vue&type=template&id=43d831fe&"
import script from "./ActionsMenuItem.vue?vue&type=script&lang=js&"
export * from "./ActionsMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports